import { readMetadata } from './readMetadata';
import { saveMetadata } from './saveMetadata';

export const removeRecordFromRegistry = (
    metadataKey: string,
    envelopeKey: string,
    storage: Storage
) => {
    const metadata = readMetadata(metadataKey, storage);
    const hasRecord = envelopeKey in metadata.registry;

    if (!hasRecord) return;

    delete metadata.registry[envelopeKey];
    saveMetadata(metadataKey, metadata, storage);
};
